// Feature flags client — loads flags from API and provides a check function.
// As of #1494 auth rides on the HttpOnly USER_JWT_COOKIE; `credentials:
// 'include'` makes the browser attach it so the server can still evaluate
// user-specific flags.

import { api_v1_features_path } from './api-routes';

let _featureFlags: Record<string, boolean> = {};

// The planner engine (planner/app.ts) and the planner entrypoint both call
// loadFeatureFlags() on startup; each call used to send its own request.
// Callers now share one, and a failed load is forgotten so the next caller
// asks again.
let _loading: Promise<void> | null = null;

export function loadFeatureFlags(): Promise<void> {
  _loading ??= fetchFlags().then((loaded) => {
    if (!loaded) _loading = null;
  });
  return _loading;
}

async function fetchFlags(): Promise<boolean> {
  try {
    const resp = await fetch(api_v1_features_path(), { credentials: 'include' });
    if (!resp.ok) return false;
    const data = await resp.json();
    _featureFlags = data.flags || {};
    return true;
  } catch {
    return false; // flags default to disabled
  }
}

export function featureEnabled(name: string) {
  return _featureFlags[name] === true;
}
